import ButtonIcon from 'common/buttons/buttonIcon';
import { Flex } from 'common/containers';
import moment from 'moment';
import { toast } from 'react-toastify';
import api from 'services/api';

interface Props {
	initialDate: string;
	endDate: string;
	businessUnit: string;
	orderStatusIds: any[];
	createdIn: string;
	productsId?: any[];
}
const DownloadReport = (props: Props) => {
	const { initialDate, endDate, businessUnit, orderStatusIds, createdIn, productsId } = props;
	const createUrl = () => {
		const urlWithParams = new URL(`${process.env.REACT_APP_API}/reports/csv`);
		urlWithParams.searchParams.set('initialDate', initialDate);
		urlWithParams.searchParams.set('endDate', endDate);
		urlWithParams.searchParams.set('businessUnit', businessUnit);
		urlWithParams.searchParams.set('createdIn', createdIn);
		orderStatusIds.forEach((id: any) => {
			urlWithParams.searchParams.append('orderStatusId[]', id);
		});
		if (productsId && productsId.length > 0) {
			productsId.forEach((id: any) => {
				urlWithParams.searchParams.append('productsId[]', id);
			});
		}
		return urlWithParams.toString();
	};
	const downloadReport = () => {
		const url = createUrl();
		api
			.get(url, { responseType: 'blob' })
			.then((response: any) => {
				const blob = new Blob([response.data], { type: 'text/csv' });
				const link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.setAttribute('download', `report_${moment().format('YYYYMMDD_HHmmss')}.xlsx`);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			})
			.catch((error: any) => {
				toast.error('Error al descargar el reporte');
			});
	};

	return (
		<Flex $h="flex-end">
			<ButtonIcon
				$text="Desscargar"
				$icon="download"
				$buttonType={'button'}
				$position="right"
				onClick={() => {
					// Logic to download the report
					downloadReport();
				}}
			/>
		</Flex>
	);
};
export default DownloadReport;
